import React, { useRef } from "react";
import Header from "../../header.js";
import Footer from "../../footer.js";
import StreamDisplay from "../../streamDisplay.jsx";
import { videoList } from "../../VideoResults/videoResultsGen3.js";

const resultsArr = videoList.Pekora;

class Pekora extends React.Component{
    render(){
    
      return(
            <div id="wrapper">

				{/* Header */}
				<Header />

				{/* Menu */}

				{/* Main */}
                <StreamDisplay talentName="Usada Pekora" results={resultsArr} />


        {/* Footer */}
            <Footer />

    </div>
    )
}
}

export default Pekora